/**
 * Utility functions to convert technical names to human-readable display names
 */

export const getToolDisplayName = (toolName: string): string => {
  const toolNameMap: Record<string, string> = {
    'ai_security': 'AI Security',
    'ai_detection': 'AI Detection',
    'ai_pattern': 'AI Pattern',
    'npm_audit': 'NPM Audit',
    'mozilla_observatory': 'Mozilla Observatory',
    'ssl': 'SSL/TLS Scan',
    'zap': 'OWASP ZAP',
    'nuclei': 'Nuclei',
    'nmap': 'Nmap',
    'crawler': 'Web Crawler',
    'api_discovery': 'API Discovery',
    'traffic_security': 'Traffic Analysis',
    'env_detection': 'Secret Scanner',
    'code_analysis': 'Code Analysis',
    'advanced_headers': 'Security Headers',
    'secrets': 'Secret Scanner',
    'traffic_analysis': 'Traffic Analysis'
  }
  return toolNameMap[toolName] || toolName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}

export const getScanTypeDisplayName = (scanType: string): string => {
  const scanTypeMap: Record<string, string> = {
    'multi': 'Multi-Tool Scan',
    'comprehensive': 'Comprehensive Scan',
    'nuclei': 'Nuclei Scan',
    'zap': 'OWASP ZAP Scan',
    'nmap': 'Network Scan',
    'nmap_quick': 'Nmap',
    'ssl': 'SSL/TLS Scan',
    'api_discovery': 'API Discovery',
    'crawler': 'Web Crawler',
    'npm_audit': 'NPM Security Audit',
    'ai_security': 'AI Security Scan',
    // FIXED: Added consistent mapping for unified scan types (removed full - only baseline scans)
    'quick': 'Zap Quick',
    'basic': 'Zap Basic',
    // Legacy support for old zap_ prefixed scan types
    'zap_quick': 'Zap Quick',
    'zap_basic': 'Zap Basic'
  }
  return scanTypeMap[scanType] || scanType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}